export default {
  namespaced: true,
  state: {
    dataList: [
      // {
      //   title: "可降解塑料检测",
      //   text: "稳定、安全、弹性、高性能的云端计算服务，实时满足您的多样性业务需求",
      //   name: "中科检测技术服务有限公司",
      // },
    ]
  }
}
